import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'shortUrl',
})
export class ShortUrlPipe implements PipeTransform {
  private readonly LIMIT = 32;

  transform(url: string): string {
    if (!url) {
      return '';
    }

    try {
      const parsedUrl = new URL(url);
      const host = parsedUrl.hostname.replace(/^www\./, '');
      const parts = parsedUrl.pathname.split('/').filter(Boolean);
      if (!parts?.length) {
        return host;
      }
      const lastPart = parts[parts.length - 1];

      const sliceUrl = parts.length > 1 ? `${host}/.../${lastPart}` : `${host}/${lastPart}`;
      return sliceUrl.length > this.LIMIT ? `${sliceUrl.slice(0, this.LIMIT)}...` : sliceUrl;
    } catch (e) {
      return url;
    }
  }
}
